module.exports = __webpack_public_path__ + "img/bkash-education-promotion.3c7e136a.jpg";